import MoreSliderBlock from './views/MoreSliderBlock.c';
export default MoreSliderBlock;
